/* eslint-disable react/prop-types */
import {Card, CardContent, Box, Grid, FormControl, InputLabel, TextField, Typography} from '@deere/fuel-react';

export default function FormEdi({register}) {
    return (
        <>
            <Card>
                <CardContent>
                    <Box mt={2}>
                        <Typography
                            component='p'
                            fontWeight='semibold'
                            gutterBottom
                            size='md'
                        >
                            {'For fastest response, please include the following'}
                        </Typography>
                        <Grid
                            alignItems='flex-start'
                            container
                            spacing={4}
                        >
                            <Grid
                                item
                                sm={3}
                                xs={6}
                            >
                                <FormControl fullWidth>
                                    <InputLabel htmlFor='partNumber'>
                                        {'Part Number'}
                                        <Box
                                            display='inline'
                                            ml={1}
                                        >
                                            <Typography
                                                color='tertiary'
                                                component='span'
                                                size='xs'
                                            >
                                                { '(Optional)' }
                                            </Typography>
                                        </Box>
                                    </InputLabel>
                                    <TextField
                                        {...register('partNumber')}
                                        fullWidth
                                        id='partNumber'
                                        placeholder=''
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                sm={3}
                                xs={6}
                            >
                                <FormControl fullWidth>
                                    <InputLabel htmlFor='purchaseOrder'>
                                        {'Purchase Order (PO) Number'}
                                        <Box
                                            display='inline'
                                            ml={1}
                                        >
                                            <Typography
                                                color='tertiary'
                                                component='span'
                                                size='xs'
                                            >
                                                { '(Optional)' }
                                            </Typography>
                                        </Box>
                                    </InputLabel>
                                    <TextField
                                        {...register('purchaseOrder')}
                                        fullWidth
                                        id='purchaseOrder'
                                        placeholder=''
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                </CardContent>
            </Card>
        </>
    );
}
